import config from '../config'


/**
 * This is a class containing data about a product that the Online Prints Editor will sell
 * Data from API's about products will be loaded into objects of this class
 *
 * @param id the identifier PAP code for the product
 * @param basePrice
 * @param options
 */
function OpeProduct(id, basePrice, options) {
    if (id === null) {
        throw new Error("Cannot create new instance of OpeProduct because the parameter id (PAP code) is null");
    }

    this.id = id;
    this.basePrice = basePrice;
    this.options = options;
}

OpeProduct.prototype.getId = function () {
    return this.id;
};

OpeProduct.prototype.getBasePrice = function () {
    return (this.basePrice * 1);
};

OpeProduct.prototype.getOptions = function () {
    return this.options;
};

OpeProduct.prototype.getUpsaleOptions = function () {
    return this.options.upsale;
};

OpeProduct.prototype.hasUpsaleOption = function (name) {
    return this.options.upsale.hasOwnProperty(name);
};

OpeProduct.prototype.addUpsaleOption = function (name, data) {
    this.options.upsale[name] = data;
};

OpeProduct.prototype.getWidthOptionPrice = function (width) {
    if (width === undefined || width === null) {
        throw new Error("Cannot get width price because given width is null");
    }
    if (this.options.printWidth[width] === undefined) {
        throw new Error("Cannot find print width:" + width + " on product " + this.id + ". Available print widths: " + JSON.stringify(this.options.printWidth));
    }
    return (this.options.printWidth[width].price * 1);
};

OpeProduct.prototype.getLineTitle = function () {
    for (var width in this.options.printWidth) {
        var title = this.options.printWidth[width].title;
        var split = title.split('x');

        if (title.indexOf("cm") >= 0) {
            return split[0].trim() + "cm";
        } else if (split.length > 1) {
            return split[1].trim();
        } else {
            return split[0].trim();
        }

    }

};

OpeProduct.prototype.getCustomSettings = function () {

    return this.options.customSettings;
};

OpeProduct.prototype.getOptionPriceByName = function (name) {
    if (name === undefined || name === null) {
        throw new Error("Cannot get option price because given name is null");
    }

    if (this.options.upsale[name] === undefined) {
        throw new Error("Cannot find upsale option with name:" + name + " on product " + this.id);
    }

    return (this.options.upsale[name].price * 1);
};

OpeProduct.prototype.removeOptionByName = function (name) {
    if (name === undefined || name === null) {
        throw new Error("Cannot remove option because given name is null");
    }

    if (this.options.upsale[name] === undefined) {
        return;
    }

    delete this.options.upsale[name];
};

OpeProduct.prototype.getOptionVendorArticleOptionIdByName = function (name) {
    if (name === undefined || name === null) {
        throw new Error("Cannot get option vendorArticleOptionId because given name is null");
    }
    if (this.options.upsale[name] === undefined) {
        throw new Error("Cannot find upsale option with name:" + name + " on product " + this.id);
    }

    return this.options.upsale[name].vendorArticleOptionId;
};

OpeProduct.prototype.getWidthVendorArticleOptionIdByWidth = function (width) {
    if (width === undefined || width === null) {
        throw new Error("Cannot getWidthVendorArticleOptionIdByWidth because given width is null");
    }
    return this.options.printWidth[width].vendorArticleOptionId;
};

OpeProduct.prototype.getWidthOptionTitle = function (width) {
    if (width === undefined || width === null) {
        throw new Error("Cannot get width title becase given width is null");
    }
    return this.options.printWidth[width].title;
};

OpeProduct.prototype.getWidthByVendorArticleOptionId = function (vendorArticleOptionId) {
    if (vendorArticleOptionId === undefined || vendorArticleOptionId === null) {
        throw new Error("Cannot get width option becase given vendorArticleOptionId is null");
    }
    for (var width in this.options.printWidth) {
        if (this.options.printWidth.hasOwnProperty(width)) {
            if (this.options.printWidth[width].vendorArticleOptionId == vendorArticleOptionId) {
                return width;
            }
        }
    }
    return null;
};

OpeProduct.prototype.removePrintWidth = function (width) {
    delete this.options.printWidth[width];
};


OpeProduct.prototype.getWidthList = function () {
    return this.options.printWidth;
};

OpeProduct.prototype.getHeight = function () {
    return this.options.height;
};

OpeProduct.prototype.getLabel = function () {
    return this.options.label;
};

export default OpeProduct;
